import { Component, OnInit, HostListener } from '@angular/core';
import { $ } from 'protractor';
import { platform } from 'os';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})



export class HomeComponent implements OnInit {
	public sidebar = true;
	public withoutSidebar = false;
	public barras;
	public largura;
	public larguraInicial;
	public overlay = false;
	public menuLateralEvent = false;
	constructor() { }

	ngOnInit() {
		this.largura = window.innerWidth;
		this.larguraInicial = window.innerWidth;
		this.sidebar = this.checkWidth(this.largura);
	}

	onResize(event){
		this.largura = event.target.innerWidth;
		if(this.largura != this.larguraInicial){
			this.unsetOverlay();
			this.larguraInicial = this.largura;
			this.sidebar = this.checkWidth(this.largura);
		}
	}

	checkWidth(width){
		if(width < 768){
			this.barras = true;
			this.withoutSidebar = true;
			return false;
		}
		else{
			this.barras = false;
			this.withoutSidebar = false;
			this.unsetOverlay();
			return true;
		}
	}

	setOverlay(){
		this.overlay = true;
	}

	unsetOverlay(){
		this.overlay = false;
		this.sidebar = false;
	}

	clickMenuLateral(event){
		if(event == true){
			this.sidebar = this.checkWidth(this.largura);
			this.overlay = false;
		}
	}


}